let preClientY = 0;
let scrollInterval;
const scrollSpeed = 150;

const mouseMove = (e) => {
    if (
        e.clientY > preClientY
        && e.clientY > screen.height - (screen.height * 0.2)
    ) {
        clearScrollInterval()
        scrollInterval = setInterval(() => {
            let windowScrollY = window.scrollY + scrollSpeed;
            window.scrollTo({ top: windowScrollY, behavior: 'smooth' });
        }, 200);
    } else if (
        e.clientY < preClientY
        && e.clientY < (screen.height * 0.1)
    ) {
        clearScrollInterval()
        scrollInterval = setInterval(() => {
            let windowScrollY = window.scrollY - scrollSpeed;
            window.scrollTo({ top: windowScrollY, behavior: 'smooth' });
        }, 200);
    }
    preClientY = e.clientY;
}

const clearScrollInterval = () => {
    if (scrollInterval)
        clearInterval(scrollInterval);
}

const scrollOnMouseMove = () => {
    window.addEventListener("mousemove", mouseMove);
}

const unsetScrollOnMouseMove = () => {
    clearScrollInterval();
    window.removeEventListener("mousemove", mouseMove);
}

export {
    scrollOnMouseMove,
    unsetScrollOnMouseMove
}